import React from 'react';
import { observer } from 'mobx-react';
import VirtualizedTable from '../common/VirtualizedTable';

export default observer(props => {
  const { height, width, items, onClickItem } = props
  const columns=[
    { key: 'jobNumber', label: 'Code', width: 80 },
    { key: 'description', label: 'Description', width: 300 },
    { key: 'usualCustomerAsString', label: 'Usual Customer', width: 250 },
    { key: 'dateCreatedAsString', label: 'Created', width: 100 },
  ]
  return <VirtualizedTable 
    height={height}
    width={width}
    items={items}
    onClickItem={onClickItem}
    columns={columns}
  />
})


// WEBPACK FOOTER //
// ./src/components/jobs/JobTable.js